import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ReportIncidentActionBaseComponent } from '@luggagehero/features/bookings';
import { SharedBookingService } from '@luggagehero/shared/services/bookings';
import { SharedNotificationService } from '@luggagehero/shared/services/notification';
import { SharedShopsService } from '@luggagehero/shared/services/shops';
import { SharedStorageService } from '@luggagehero/shared/services/storage';
import { SharedUserService } from '@luggagehero/shared/services/users';
import { TranslateService } from '@ngx-translate/core';
import { FileUploader } from 'ng2-file-upload';

@Component({
  selector: 'lh-report-incident-action',
  templateUrl: './report-incident-action.component.html',
  styleUrls: ['./report-incident-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportIncidentActionComponent extends ReportIncidentActionBaseComponent implements OnInit {
  public uploader: FileUploader;
  public constructor(
    translate: TranslateService,
    bookingService: SharedBookingService,
    shopsService: SharedShopsService,
    storageService: SharedStorageService,
    cd: ChangeDetectorRef,
    notificationService: SharedNotificationService,
    private userService: SharedUserService,
  ) {
    super(translate, bookingService, shopsService, storageService, cd, notificationService);
  }

  get imageUploadUrl(): string {
    return this.bookingService.getIncidentImageUploadUrl(this.booking._id);
  }

  async ngOnInit() {
    await super.ngOnInit();

    this.uploader = new FileUploader({
      isHTML5: true,
      maxFileSize: 20 * 1024 * 1024,
      allowedMimeType: ['image/png', 'image/jpg', 'image/jpeg', 'image/gif'],
      autoUpload: true,
      removeAfterUpload: true,
      url: this.imageUploadUrl,
    });

    if (this.userService.isLoggedIn) {
      this.uploader.options.authToken = `Bearer ${this.userService.accessToken}`;
    }

    this.uploader.onBeforeUploadItem = (item) => {
      // Show the local image to the user right away
      this.localIncidentImage = URL.createObjectURL(item.file.rawFile as unknown as Blob);
      this.cd.markForCheck();
    };

    this.uploader.onCompleteAll = async () => {
      const booking = await this.bookingService.getBooking(this.booking._id, true);
      this.updateBooking(booking);

      if (this.localIncidentImage && this.booking.incidentImages && this.booking.incidentImages.length > 0) {
        this.remoteIncidentImage = this.booking.incidentImages[0];
        this.imageName = this.booking.incidentImages[0];
        console.log('Added remote incident image');
      }
    };

    this.uploader.onWhenAddingFileFailed = (item) => {
      if (item.size > this.uploader.options.maxFileSize) {
        const mb = (item.size / 1024 / 1024).toFixed(2);
        console.log(`${item.name} (${mb} MB) -- FILE_TOO_LARGE`);
      } else {
        console.log(`${item.name} -- UPLOAD_FAILED`);
      }
    };

    this.uploader.onErrorItem = (item) => {
      console.log(`${item.file.name} -- UPLOAD_FAILED`);
    };

    this.uploader.onSuccessItem = (item) => {
      console.log(`${item.file.name} -- UPLOAD_SUCCEEDED`);
    };
  }
}
